import React from "react";

const MaleAvatarIcon = ({
  size = 32,
  backgroundColor = "#D2C3B1",
  color = "#3C2212",
  strokeWidth = 2,
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect
        width="32"
        height="32"
        rx="16"
        fill={backgroundColor}
      />

      <path
        d="M17.8 19.2335V20.7374H18.925C21.0007 20.7374 22.7481 22.1689 23.2678 24.0885C23.4409 24.7283 22.8878 25.2749 22.225 25.2749H10C9.33731 25.2749 8.78417 24.7283 8.95734 24.0885C9.477 22.1689 11.2244 20.7374 13.3 20.7374H14.425V19.2335"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />

      <path
        d="M20.05 12.8623V15.6748C20.05 17.8494 18.2872 19.6123 16.1125 19.6123C13.9379 19.6123 12.175 17.8494 12.175 15.6748V12.8623H12.7482C14.0787 12.8623 15.2682 12.2121 16.2091 11.2713C16.6162 10.8642 17.1787 10.6123 17.8 10.6123C19.0427 10.6123 20.05 11.6197 20.05 12.8623Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />

      <path
        d="M17.7998 20.7372L18.5422 21.4795C19.0108 21.9481 19.0108 22.7079 18.5423 23.1765L17.7033 24.0156L16.1123 22.4246L14.5213 24.0156L13.6824 23.1765C13.2138 22.7079 13.2138 21.9481 13.6824 21.4795L14.4248 20.7372"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />

      <path
        d="M14.425 20.7373L16.1125 22.4248L17.8 20.7373"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />

      <path
        d="M12.175 12.8623C10.6218 12.8623 9.36255 11.6031 9.36255 10.0498C9.36255 9.11257 9.821 8.26875 10.5259 7.74684C11.3103 7.16603 12.324 8.32481 13.3 8.32481H17.8C19.0427 8.32481 20.05 9.36967 20.05 10.6123V12.8623"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default MaleAvatarIcon;